'use strict';

var dataId = require('./data-id.cjs');

function getOptimisedAppearId(visualElement) {
    return visualElement.props[dataId.optimizedAppearDataAttribute];
}

exports.getOptimisedAppearId = getOptimisedAppearId;
//# sourceMappingURL=get-appear-id.cjs.map
